module.exports = __webpack_public_path__ + "static/media/07.09987c5a.mp3";